import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	display: flex;
	align-items: flex-start;
	justify-content: center;
	::-webkit-scrollbar {
		display: none; /* Oculta a barra de rolagem */
	}
`;

export const centralize = styled.div`
	width: 100%;
	padding: 8px 8px 0 8px;
	display: flex;
	align-items: flex-start;
	justify-content: center;
`;

export const boxApp = styled.div`
	width: 100%;
	background-color: ${color.interface.white};
	border-radius: 5px;
	padding: 10px;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	align-items: center;
	justify-content: flex-start;
`;

export const date = styled.p`
	width: 100%;
	font-size: 1.4rem;
	text-align: left;

	color: ${color.interface.darkgray};
`;

export const title = styled.p`
	font-family: nunito-bold;
	width: 100%;
	font-size: 1.5rem;
	text-align: left;
	color: ${color.interface.darkgray};
`;

export const description = styled.p`
	width: 100%;
	font-size: 1.3rem;
	color: ${color.interface.darkgray};
	overflow: hidden;

	img {
		max-width: 100%;
		height: auto;
	}
`;

export const button = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	> button {
		all: unset;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 0.5rem;
		font-family: nunito-bold;
		padding: 10px;
		border-radius: 7px;
		background-color: #4f2170;
		font-size: 1.3rem;
		color: ${color.interface.white};

		> svg {
			font-size: 1.8rem;
		}
	}
`;

export const img = styled.div`
	width: 100%;

	> img {
		width: 100%;
		background-color: ${color.interface.lightGray2};
		border-radius: 5px;
	}
`;
